import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import {
  Home,
  Material,
  Register,
  Report,
  Mainpage,
  CreatorSonar,
  ContainerManager,
  AdManagerReportForm,
  AdManagerReportFormLink,
} from './pages'
import { AppWrapper, ContextProvider } from './components'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-bootstrap-typeahead/css/Typeahead.css'

function App() {
  return (
    <div className="App">
      <Router>
        <ContextProvider>
          <AppWrapper>
            <Routes className="px-0">
              <Route path="/" element={<Home />} />
              <Route path="/mainpage" element={<Mainpage />} />
              <Route path="/material" element={<Material />} />
              <Route path="/report" element={<Report />} />
              <Route path="/register" element={<Register />} />
              <Route path="/creator" element={<CreatorSonar />} />
              <Route path="/ContainerManager" element={<ContainerManager />} />
              <Route
                path="/insights/:token"
                element={<AdManagerReportFormLink />}
              />
              <Route
                path="/AdManagerReportForm"
                element={<AdManagerReportForm />}
              />
              <Route path="/*" element={<Home />} />
            </Routes>
          </AppWrapper>
        </ContextProvider>
      </Router>
    </div>
  )
}

export default App
